import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'
import { forwardRef } from 'react'

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow', // David - 2025-07-21 - Removed hover style
        secondary: 'border-transparent bg-secondary text-secondary-foreground', // David - 2025-07-21 - Removed hover style
        destructive: 'border-transparent bg-destructive text-destructive-foreground', // David - 2025-07-21 - Removed hover style
        outline: 'text-foreground', // David - 2025-07-21 - Removed hover style
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(({ className, variant, ...props }, ref) => {
  return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
})

Badge.displayName = 'Badge'

export { Badge, badgeVariants }
